<template>
  <div class="main">
    <Head />

    <Navbar activeMenu="网站首页" />

    <div class="banner"></div>

    <div class="center">
      <div class="news">
        <div
          class="leftPic"
          @click="openReading"
        >
          <img src="../assets/reading.jpg" />
          <p>2023年度中国数字阅读用户现状调研</p>
        </div>

        <div class="rightNews">
          <div class="newsIcon">
            <div class="icon">
              <img src="../assets/icon-news.png" />
            </div>
            <div class="line"></div>
          </div>

          <div
            class="newsList"
            @click="$router.push('/newsDetail/107')"
          >
            <div class="date">
              <p class="day">18</p>
              <p class="month">2023-10</p>
            </div>
            <div class="content">
              <p class="title">2023安徽省全民健身广场舞大赛</p>
              <p class="text">
                10月15日，“养固健杯”2023安徽省全民健身广场舞大赛（合肥老城站）预赛在合肥城隍庙广场举行。来自合肥庐阳区、瑶海区、蜀山区、包河区、高新区等地各社区的20余支群众文体社团参...
              </p>
            </div>
          </div>

          <div
            class="newsList"
            @click="$router.push('/newsDetail/108')"
          >
            <div class="date">
              <p class="day">18</p>
              <p class="month">2023-09</p>
            </div>
            <div class="content">
              <p class="title">乐龄听书开启第三届“聆听军功章里的故事”展播</p>
              <p class="text">
                为纪念抗美援朝胜利70周年，致敬志愿军战士，安徽省退役军人事务厅主办、安徽科学技术出版社承办的第三届“聆听军功章里的故事”开启征集活动。经过一个半月的征集、筛选，现乐龄听书...
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="info">
      <div class="container">
        <div class="download">
          <img src="../assets/download.jpg" />
          <img
            class="appImg"
            src="../assets/app.jpg"
          />
          <p>乐龄听书移动端下载</p>
          <img
            class="appImg"
            src="../assets/miniCode.jpg"
          />
          <p>乐龄听书微信小程序</p>
        </div>

        <div class="video">
          <div class="videoImg">
            <img src="../assets/video.jpg" />
          </div>
          <div class="videoContainer">
            <div
              class="videoPlay"
              @click="$router.push('/videoPlay/936')"
            >
              <div class="cover">
                <img
                  src="https://image.llts.com.cn/image/web/fa08a3a447222526d106cfcb5d946be1.jpg"
                />
                <div class="mask"></div>
              </div>
              <p>二十四节气里的中医养生智慧 大寒</p>
            </div>
            <div
              class="videoPlay"
              @click="$router.push('/videoPlay/412')"
            >
              <div class="cover">
                <img
                  src="https://image.llts.com.cn/image/web/5d51b04915a6ad36f438b464a8f509e2.jpg"
                />
                <div class="mask"></div>
              </div>
              <p>关公提刀上灞桥</p>
            </div>
            <div
              class="videoPlay"
              @click="$router.push('/videoPlay/406')"
            >
              <div class="cover">
                <img
                  src="https://image.llts.com.cn/image/web/04a17470957742546d564c20d6f289aa.jpg"
                />
                <div class="mask"></div>
              </div>
              <p>庐州太极精编三十六式</p>
            </div>
            <div
              class="videoPlay"
              @click="$router.push('/videoPlay/264')"
            >
              <div class="cover">
                <img
                  src="https://image.llts.com.cn/image/web/704d755166d037849ffea7ea1b9b95fe.jpg"
                />
                <div class="mask"></div>
              </div>
              <p>白肉PK红肉</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import Head from './index/Head.vue';
import Navbar from './index/Navbar.vue';
import Footer from './index/Footer';

export default {
  data() {
    return {
      checkCode: '',
      userName: '',
      phoneNumber: '',
      realName: '',
      idCard: '',
      enableLogin: false,
      loginChecked: false,
      isLoginShow: false,
      countDownNum: '发送验证码',
      isCountDown: false,
      classObject: { sendCode: true, sendColor: false },
      loginEnable: false,
      loginOutShow: false,
      isloginOffMaskShow: false,
    };
  },
  created() {},
  mounted() {},

  beforeDestroy() {},

  computed: {},

  watch: {},

  methods: {
    openReading() {
      window.open('https://www.wjx.cn/vm/rk2uewC.aspx');
    },
  },
  components: { Head, Navbar, Footer },
};
</script>

<style lang="less" scoped>
@import '../assets/css/index.less';
</style>
